import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-activity-tab',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TitleCasePipe],
  templateUrl: './activity-tab.component.html',
  styleUrl: './activity-tab.component.scss'
})
export class ActivityTabComponent {
  @Input() activityNumber!: number;
  @Input() completionCount!: number;
  @Input() totalQuestions!: number;
  @Input() noAnswerCount = 0;
  @Input() isActive = false;
  @Input() activityStatus?: 'draft' | 'submitted' | 'approved' | 'rejected';
  @Input() displayName?: string;
  @Input() isActionRequiredOnReject = false;
  @Output() readonly selectTab = new EventEmitter<void>();

  get cleanDisplayName(): string | undefined {
    // Filter out "unknown" or "Unknown" values - treat as empty
    if (!this.displayName) return undefined;
    return (this.displayName.toLowerCase() === 'unknown') ? undefined : this.displayName;
  }
}
